module.exports = __webpack_public_path__ + "img/icon_status_-2@3x.b53609e2.png";